import { Component, OnInit, OnDestroy } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { Subscription } from 'rxjs/Subscription';

import { Restaurant } from './restaurant';

import { RestaurantService } from './restaurant.service';

import { MessageService }     from './message.service';

import 'rxjs/add/operator/switchMap';

@Component({
	selector: 'review',
	template:'<div>   <navigation></navigation><reviews></reviews><contact-us></contact-us><timetable-location></timetable-location><footer></footer></div>',
        styleUrls: ['./review-list.component.css'] 
})
export class ReviewListComponent  {

 deviceInfo = null;
        device = "unknown";
	constructor(
		
   
  	) {}


}




// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/review-list.component.ts